// # About tab component for profile page
import React from 'react';
import { capitalizeFirstLetter } from '../profile';
import { nationalityData } from '../../../utils/nationality_data';
import { FaMars, FaVenus, FaEnvelope, FaPhone, FaGraduationCap, FaBookReader, FaChartLine } from 'react-icons/fa';
import { MdPublic } from 'react-icons/md';
import './prfl_about.css';

const ProfileAbout = ({ displayProfile }) => {
  // # Get nationality data with flag
  const getNationalityWithFlag = (nationalityKey) => {
    if (!nationalityKey) return 'Not specified';
    const nationality = nationalityData[nationalityKey];
    if (!nationality) return capitalizeFirstLetter(nationalityKey);
    return `${nationality.flag} ${nationality.name}`;
  };

  // # Get gender with icon
  const getGenderWithIcon = (gender) => {
    if (!gender) return <span className="prfl_abt_not-specified">Not specified</span>;
    
    return (
      <span className={`prfl_abt_gender-display ${gender.toLowerCase()}`}>
        {gender.toLowerCase() === 'male' ? (
          <FaMars className="prfl_abt_gender-icon male" />
        ) : (
          <FaVenus className="prfl_abt_gender-icon female" />
        )}
        {capitalizeFirstLetter(gender)}
      </span>
    );
  };

  // # Format phone number with country code from Firestore data
  const formatPhoneNumber = (phoneNumber, selectedCountry) => {
    // # Handle case when either phoneNumber or selectedCountry is missing
    if (!phoneNumber || !selectedCountry) return 'Not provided';
    
    try {
      // # Get country data from profile's selectedCountry
      const defaultCountry = {
        code: '+20',
        flag: '🇪🇬',
        name_en: 'Egypt'
      };
      
      // # Get the selectedCountry from the profile data
      const countryData = selectedCountry || defaultCountry;
      
      // # Ensure the country code starts with '+'
      const countryCode = countryData.code.startsWith('+') ? 
        countryData.code : 
        `+${countryData.code}`;
      
      // # Phone number is already stored without country code
      return (
        <span className="prfl_abt_phone-display">
          <span className="prfl_abt_country-code">
            {countryData.flag} {countryCode}
          </span>
          <span className="prfl_abt_phone-number">{phoneNumber}</span>
        </span>
      );
    } catch (error) {
      console.error('Error formatting phone number:', error);
      return 'Not provided';
    }
  };

  return (
    <div className="prfl_abt_tab-content">
      {/* # Personal Information */}
      <div className="prfl_abt_info-section">
        <h3>Personal Information</h3>
        <div className="prfl_abt_info-grid">
          <div className="prfl_abt_info-item">
            <label>
              <FaEnvelope className="prfl_abt_info-icon" />
              Email
            </label>
            <p>{displayProfile?.email || 'Not provided'}</p>
          </div>
          <div className="prfl_abt_info-item">
            <label>
              <FaPhone className="prfl_abt_info-icon" />
              Phone
            </label>
            <p>{formatPhoneNumber(displayProfile?.phoneNumber, displayProfile?.selectedCountry)}</p>
          </div>
          <div className="prfl_abt_info-item">
            <label>
              {displayProfile?.gender?.toLowerCase() === 'male' ? 
                <FaMars className="prfl_abt_info-icon" /> : 
                <FaVenus className="prfl_abt_info-icon" />
              }
              Gender
            </label>
            <p>{getGenderWithIcon(displayProfile?.gender)}</p>
          </div>
          <div className="prfl_abt_info-item">
            <label>
              <MdPublic className="prfl_abt_info-icon" />
              Nationality
            </label>
            <p>{getNationalityWithFlag(displayProfile?.nationality)}</p>
          </div>
        </div>
      </div>

      {/* # Biography Section */}
      {displayProfile?.profile?.biography && (
        <div className="prfl_abt_info-section">
          <h3>Biography</h3>
          <div className="prfl_abt_biography">
            <p>{displayProfile.profile.biography}</p>
          </div>
        </div>
      )}

      {/* # Academic Information */}
      <div className="prfl_abt_info-section">
        <h3>Academic Information</h3>
        <div className="prfl_abt_info-grid">
          <div className="prfl_abt_info-item">
            <label>
              <FaGraduationCap className="prfl_abt_info-icon" />
              University
            </label>
            <p>{capitalizeFirstLetter(displayProfile?.university) || 'Not provided'}</p>
          </div>
          <div className="prfl_abt_info-item">
            <label>
              <FaBookReader className="prfl_abt_info-icon" />
              Current Phase
            </label>
            <p>{capitalizeFirstLetter(displayProfile?.phase) || 'Not specified'}</p>
          </div>
          <div className="prfl_abt_info-item">
            <label>
              <FaChartLine className="prfl_abt_info-icon" />
              GPA
            </label>
            <p>{displayProfile?.gpa || 'Not provided'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileAbout;
